import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Dropdown } from "react-bootstrap";
import toast from 'react-hot-toast';
import { getProfileData } from '../../../Redux/action/MasterAction';
import { jwtDecode } from "jwt-decode";

import { useDispatch, useSelector } from 'react-redux';
import { getStudentSmallNotificationListData } from '../../../Redux/action/StudentAction';
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER
const StudentHeader = () => {
    const authToken = localStorage.getItem('student-token');

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
    };

    const { pathname } = useLocation();
    useEffect(() => {
        if (authToken) {
            const decoded = jwtDecode(authToken);

            if (!decoded?.user?.id) {
                localStorage.removeItem("student-token");
                navigate('/login', { state: { user: 'student' } })
            }
            else {
                localStorage.removeItem("tutor-token");
            }
        }
        else {

            navigate('/login', { state: { user: 'student' } })
        }

    }, [authToken, navigate])

    useEffect(() => {
        dispatch(getProfileData(authToken));
        dispatch(getStudentSmallNotificationListData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

    } = useSelector(state => state?.MasterReducer);

    const {
        loadingStudentSmallNotificationListApi,
        StudentSmallNotificationListApiData,
        StudentSmallNotificationListApiError

    } = useSelector(state => state?.StudentReducer);


    const markNotificationsAsRead = async (notificationId) => {
        try {
            const config = {
                headers: {
                    "x-auth-token": localStorage.getItem('student-token'), // Custom header with the token
                }
            }
            const response = await axios.post(`${host}/api/web/notification-read`, {
                notificationId,
            }, config);
            dispatch(getStudentSmallNotificationListData())
            navigate('/student/notification')
        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    };

    const handleViewAllClick = () => {
        const allNotificationIds = StudentSmallNotificationListApiData.map((data) => data.id);
        markNotificationsAsRead(allNotificationIds);
    };

    const handleNotificationClick = (notificationId) => {
        markNotificationsAsRead([notificationId]);
    };

    if (ProfileDataListApiError) {
        console.log('err', ProfileDataListApiError)

        if (ProfileDataListApiError == "Your account has been logged in from another device. Please sign in again.") {
            localStorage.removeItem("student-token");
            navigate('/login', { state: { user: 'student' } });
        }
    }


    return (
        <div className="header-top-sec bg-light">
            <header>
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid px-5">
                        <div className="row header-row">
                            {/* <div className="col-lg-0 col-md-1 col-sm-1 d-flex align-items-center justify-content-center asidebar">
                                <button id="sidebarToggle" className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                    <span className="navbar-toggler-icon" />
                                </button>
                            </div> */}
                            <div className="col-lg-2 col-md-3 col-sm-2 weblogo">
                                <Link className="navbar-brand" href="#">
                                    <img src="/website/assets/img/logo.png" className="img-fluid" />
                                </Link>
                            </div>
                            <div className="col-lg-7 col-md-5 col-sm-6 header-text">
                                <h4 className="mb-0 fw-lighter">Hello, {ProfileDataListApiData?.data?.name}</h4>
                                <p className="mb-0">
                                     Start Learning!
                                </p>
                            </div>
                            <div className="col-lg-3 col-md-3  col-sm-3 notification-profile-sec">
                                <ul className="navbar-nav mb-2 mb-lg-0">
                                    <li className="nav-item dropdown">

                                        <Dropdown>
                                            <Dropdown.Toggle variant="link" drop="start">
                                                <i className="fa-solid fa-bell" />
                                                <span className="badge badge-warning navbar-badge text-danger">
                                                    {StudentSmallNotificationListApiData?.length ? StudentSmallNotificationListApiData?.length : '0'}
                                                </span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'scroll' }}>
                                                {StudentSmallNotificationListApiData?.length > 0 ? (
                                                    <>
                                                        {StudentSmallNotificationListApiData.map((data, index) => (
                                                            <Dropdown.Item
                                                                key={index}

                                                                onClick={() => handleNotificationClick(data.id)} // Call API for individual notification
                                                            >
                                                                <i className="fas fa-envelope mr-2"></i> {data?.message}
                                                            </Dropdown.Item>
                                                        ))}
                                                        {StudentSmallNotificationListApiData.length > 2 && (
                                                            <Dropdown.Item

                                                                className="text-center fw-bold border-1 border-top"
                                                                onClick={handleViewAllClick} // Call API for all notifications
                                                            >
                                                                View All Notifications
                                                            </Dropdown.Item>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Dropdown.Item disabled>No notifications available</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="link">
                                                <img
                                                    src={`${host}${ProfileDataListApiData?.data?.profile_img}`}
                                              
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                    alt="User profile image"
                                                />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to="/student/profile">
                                                    Profile
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal">
                                                    Logout
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-0 col-md-1 col-sm-1 d-flex align-items-center justify-content-center asidebar">
                                <button id="sidebarToggle" className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                    <span className="navbar-toggler-icon" />
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            {isSidebarOpen && (
                <div className="responsive-sidebar navbar-light">
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                        <h5 className="mb-0">Menu</h5>
                        <button className="btn btn-link text-dark fs-4" onClick={toggleSidebar}>
                            <i className="fa fa-times" />
                        </button>
                    </div>
                    <ul className="nav flex-column p-3 navbar-nav">
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/dashboard' ? 'active' : ''}`} to="/student/dashboard" onClick={toggleSidebar}>
                                <i className="fa-solid fa-house-chimney" /> &nbsp;Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/browse-tutor' ? 'active' : ''}`} to="/student/browse-tutor" onClick={toggleSidebar}>
                                <i className="fas fa-chalkboard-teacher" /> &nbsp;Tutors
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/request-for-tutor' ? 'active' : ''}`} to="/student/request-for-tutor" onClick={toggleSidebar}>
                                <i className="fa-solid fa-hand" /> &nbsp;Request Tutor
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/my-sessions' ? 'active' : ''}`} to="/student/my-sessions" onClick={toggleSidebar}>
                                <i className="fa-solid fa-video" /> &nbsp;My Sessions
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/my-online-lecture' ? 'active' : ''}`} to="/student/my-online-lecture" onClick={toggleSidebar}>
                                <i className="fa-solid fa-earth-americas" /> &nbsp;My Online Lectures
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/notes-and-handouts' ? 'active' : ''}`} to="/student/notes-and-handouts" onClick={toggleSidebar}>
                                <i className="fa-solid fa-file-contract" /> &nbsp;Notes & Handouts
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/my-assignments' ? 'active' : ''}`} to="/student/my-assignments" onClick={toggleSidebar}>
                                <i className="fa-solid fa-note-sticky" /> &nbsp;My Assignments
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/bookings' ? 'active' : ''}`} to="/student/bookings" onClick={toggleSidebar}>
                                <i className="fa fa-clock-o" /> &nbsp;Booking
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/message' ? 'active' : ''}`} to="/student/message" onClick={toggleSidebar}>
                                <i className="fa-solid fa-comments" /> &nbsp;Message
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/my-queries' ? 'active' : ''}`} to="/student/my-queries" onClick={toggleSidebar}>
                                <i className="fa-solid fa-clipboard-question" /> &nbsp;My Queries
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathname === '/student/contact-us' ? 'active' : ''}`} to="/student/contact-us" onClick={toggleSidebar}>
                                <i className="fa-solid fa-users" /> &nbsp;Contact Us
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link text-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={toggleSidebar}
                            >
                                <i className="fa-solid fa-right-from-bracket" /> &nbsp;Logout
                            </Link>
                        </li>
                    </ul>
                </div>
            )}



        </div>

    )
}

export default StudentHeader